
        document.addEventListener('click', function (e) {
            if (e.target && e.target.classList.contains('videoPlaceholder')) {
                var clickedImage = e.target;
                var ytVideoContainer = document.createElement('div');
                ytVideoContainer.className = 'yt-video-container';

                var ytVideoWrapper = document.createElement('div');
                ytVideoWrapper.className = 'yt-video-wrapper';

                var closeBtn = document.createElement('button');
                closeBtn.className = 'close-btn';
                closeBtn.innerText = 'X';

                // Create a new iframe element
                var ytVideo = document.createElement('iframe');
                ytVideo.setAttribute('allow', 'autoplay');
                ytVideo.setAttribute('frameborder', '0');
                ytVideo.setAttribute('allowfullscreen', '');

                // Get the video ID from the data attribute of the clicked element
                var videoId = clickedImage.getAttribute('data-vid');
                ytVideo.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';

                // Clear existing iframes and append the new iframe
                ytVideoWrapper.appendChild(ytVideo);
                ytVideoWrapper.appendChild(closeBtn);
                ytVideoContainer.appendChild(ytVideoWrapper);
                document.body.appendChild(ytVideoContainer);

                ytVideoContainer.style.display = 'flex';

                // Close video container on close button click
                closeBtn.addEventListener('click', function () {
                    ytVideoContainer.style.display = 'none';
                    ytVideoContainer.remove();
                });

                // Close video container on click outside
                ytVideoContainer.addEventListener('click', function (event) {
                    if (event.target === ytVideoContainer) {
                        ytVideoContainer.style.display = 'none';
                        ytVideoContainer.remove();
                    }
                });
            }
        });
  